import delegate from "delegate-it";
import ajax from "@/scripts/common/ajax";
import { scrollToIfNeeded } from "@/scripts/common/scroll-to";
import { updateQueryParams } from "@/scripts/common/util";

const updateResults = async () => {
  const pageContent = document.querySelector("[data-page-content]");

  pageContent.classList.add("is-loading");

  const res = await ajax.get(window.location.href).json();

  pageContent.innerHTML = res.page;
  pageContent.classList.remove("is-loading");

  if (res.isFiltered) {
    scrollToIfNeeded(pageContent, 24);
  }
};

const handleViewChange = (e) => {
  document.querySelector('[data-change-view][aria-selected="true"]').setAttribute("aria-selected", "false");
  e.delegateTarget.setAttribute("aria-selected", "true");

  const url = updateQueryParams([["view", e.delegateTarget.dataset.changeView]]);

  window.history.replaceState({}, "", url);

  updateResults();
};

const handleFilterClear = () => {
  const url = new URL(window.location.href);
  const view = url.searchParams.get("view");

  url.search = "";

  if (view) url.searchParams.set("view", view);

  window.history.replaceState({}, "", url);

  updateResults();
};

const handleFilterChange = (e) => {
  const { name, value } = e.detail ?? {};

  if (!name) return;

  const url = updateQueryParams([[name, value || false]]);
  window.history.replaceState({}, "", url);

  updateResults();
};

document.addEventListener("DOMContentLoaded", () => {
  delegate('[data-change-view]:not([aria-selected="true"])', "click", handleViewChange);
  document.addEventListener("events:filter-clear", handleFilterClear);
  document.addEventListener("events:filter-change", handleFilterChange);
});
